export default __webpack_public_path__ + "d022bc70dc1bf7b3425da9cdaa9841b6.woff2";